<template>
  <v-container fluid>
    <feature-streamer v-model="featuredStream" @refresh="this.featureRandomStreamer" :grassroots="currentGrassroots" />
    
    <v-layout row wrap justify-center>
      <v-flex xs12 sm8 no-wrap>
        <v-divider class="mt-2" />
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-center>
        <v-flex xs12 sm4 mb-2>
          <game-select :games="games" v-model="selectedGames" />
        </v-flex>
        <v-flex xs12 sm3 offset-sm1 class="mb-2">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details clearable />
        </v-flex>
    </v-layout>

    <v-layout row wrap justify-center>
      <v-flex xs12 lg10 xl10>
        <v-data-table ref="streamDataTable" :headers="headers" :items="filteredStreams" item-key="_id" :loading="!isLoaded" :footer-props="{itemsPerPageOptions:[100,200,-1]}" :expanded.sync="expanded" :must-sort="true" :sort-by.sync="sortBy" :sort-desc.sync="sortDescending" :search="search" class="elevation-1" >
          <v-progress-linear v-slot:progress color="purple" indeterminate></v-progress-linear>
          <template v-slot:item.preview="{ item }">
            <v-hover>
              <span slot-scope="{ hover }">
                <v-img v-if='hover' width="640px" :src="item.preview.large" style="z-index: 10;position: absolute;margin-left:10vw" />
                <a :href="item.channel.url"><v-img width="10vw" :src="item.preview.medium" /></a>
              </span>
            </v-hover>
          </template>

          <template v-slot:item.viewers="{ item }">
            {{ item.viewers }}
          </template>

          <template v-slot:item.channel.name="{ item }">
            <twitch-channel-link :channel='item.channel' />
          </template>

          <template v-slot:expanded-item="{ item }">
            <td :colspan="headers.length">
              <a :href="item.channel.url"><v-img max-width="100vw" :src="item.preview.medium" /></a>
            </td>
          </template>

          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import sort from 'fast-sort'
import TwitchWrapper from '@/TwitchWrapper'
import TwitchChannelLink from '@/components/TwitchChannelLink'
import TwitchStreamCard from '@/components/TwitchStreamCard'
import GameSelect from '@/components/GameSelect'
import FeatureStreamer from '@/components/FeatureStreamer'

export default {
  name: 'TwitchStreamList',
  components: {
    TwitchChannelLink,
    TwitchStreamCard,
    GameSelect,
    FeatureStreamer
  },
  computed: {
    filteredData () {
      if(this.$refs.streamDataTable)
        return this.$refs.streamDataTable.vdata.filteredItems
      else
        return [];
    },
    filteredStreams () {
        if(this.selectedGames.length > 0)
        {
          return this.streams.filter(s => this.selectedGames.includes(s.game))
        }
        return this.streams
    },
    currentGrassroots () {
      let currDate = new Date()
      let g = this.grassroots.filter(g => {
        let start = new Date(g.startDate)
        let end = new Date(g.endDate)
        if(currDate >= start && currDate <= end){
          return true
        }
        return false
      })

      if(g.length > 0)
      {
        let grassrootsStream = this.streams.filter(s => s.channel.name == g[0].channel)
        if(grassrootsStream.length > 0)
          return grassrootsStream[0]
      }

      return null
    },
    expanded() {
      if (this.$vuetify.breakpoint.xsOnly){
        return this.filteredStreams
      }
      return []
    },
    headers() {
      let headers = [
        { text: 'Game', value: 'game',},
        { text: 'Viewers', value: 'viewers', align:'center', },
        { text: 'Uptime', value: 'uptime', align:'center', },
      ]

      if (this.$vuetify.breakpoint.smAndUp) {
        headers.unshift({ text: 'Status', value: 'channel.statusShort', align: 'left'})
        headers.unshift({ text: 'Channel', value: 'channel.name', align: 'left',  })
        headers.unshift({ text: 'Preview', value: 'preview', align: 'left', sortable: false})
      }
      else {
        headers.unshift({ text: 'Status', value: 'channel.statusMobile', align: 'left'})
        headers.unshift({ text: 'Channel', value: 'channel.name', align: 'left',  })
      }
      return headers
    },
  },
  data () {
    return {
      isLoaded: false,
      games: [],
      streams: [],
      channels: [],
      featuredStream: null,

      grassroots: [
        {channel: 'tremyirl', startDate: '2020-07-06 GMT+10', endDate: '2020-07-20 GMT+10'},
        {channel: 'yasietv', startDate: '2020-07-20 GMT+10', endDate: '2020-08-03 GMT+10'},
        {channel: 'rayinthecity', startDate: '2020-08-03 GMT+10', endDate: '2020-08-17 GMT+10'},
        {channel: 'jordanrasko', startDate: '2020-08-17 GMT+10', endDate: '2020-08-31 GMT+10'},
        {channel: 'itsmixnmax', startDate: '2020-08-31 GMT+10', endDate: '2020-09-14 GMT+10'},
      ],
      
      search: '',
      selectedGames: [],
      twitch: new TwitchWrapper(this.$root.$data.clientId),

      sortBy: 'viewers',
      sortDescending: true,
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      this.isLoaded = false
      this.twitch.GetANZStreams().then(s => {
          this.streams = s.streams.map(i => {
            i.uptime = this.UptimeFormat(this.UptimeSeconds(i.created_at))
            i.channel.statusShort = i.channel.status.slice(0,65)
            if (i.channel.status.length > 65){i.channel.statusShort += "..."}

            i.channel.statusMobile = i.channel.status.slice(0,35)
            if (i.channel.status.length > 35){i.channel.statusMobile += "..."}

            return i
          })
          this.channels = s.channels

          // Games drop down
          let games = this.streams.map(stream => stream.game).getUnique()
          games = sort(games).asc(g => g.toUpperCase())
          this.games = games.map(g => {
             return {
               name: g, 
               count: this.streams.filter(z => z.game == g).length  
          }})

          // random stream
          this.featureRandomStreamer()

          this.$emit('subtitleUpdate', `${s.channels.length} ANZ Channels, ${s.streams.length} live`)
          this.$forceUpdate()

          this.isLoaded = true
      }).catch(this.errorHandle)
    },
    UptimeSeconds: function(created_at) {
      var start = new Date(created_at).getTime();
      var now = new Date().getTime();
      return (now - start) / 1000;
    },
    UptimeFormat: function(uptime) {
      var hours = parseInt(uptime / 3600);
      var minutes = parseInt((uptime - (hours * 3600)) / 60)
      return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
    },
    toggle () {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.selectedFruits = []
        } else {
          this.selectedFruits = this.fruits.slice()
        }
      })
    },
    featureRandomStreamer() {
      this.featuredStream = this.streams[Math.floor((Math.random() * this.streams.length) + 0)]
    },
    errorHandle(e) {
      try { this.$emit('errorUpdate', JSON.parse(e.message).message) }
      catch {this.$emit('errorUpdate', e) }
    }
  }
}

Array.prototype.getUnique = function() {
    return Array.from(new Set(this))
};
</script>

<style>
</style>